export const componentsMixin = {
	methods: {
		// 防抖
		debounce (fn, timeInterval) {
			if (this.timerMixin) {
				clearTimeout(this.timerMixin)
			}
			let arg = [ ...arguments ].filter((item, index) => {
				return index > 1
			})
			this.timerMixin = setTimeout(() => {
				fn.apply(this, arg)
			}, timeInterval)
		},
		// 函数节流
		throttle (fn, gapTime) {
			let _lastTime = null
			return function () {
				let _nowTime = +new Date()
				if (_nowTime - _lastTime > gapTime || !_lastTime) {
					fn()
					_lastTime = _nowTime
				}
			}
		}
	}
}
